import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const LineHeight = styled.div`
  line-height: ${token('space.200')};
`;
